import { getUserPreferencesNotifications } from 'state/selectors';
import { AppState } from 'state/state.model';

import type { TradeInfos, TradeInfosMap } from './trades.model';
import { initialTradeInfos } from './trades.model';

export function getTradeInfos(state: TradeInfosMap, quoteId: string | undefined): TradeInfos {
  if (quoteId) {
    return state[quoteId] ?? initialTradeInfos;
  }
  return initialTradeInfos;
}

const emptyContacts: string[] = [];

export function getTradeNotificationsContacts(state: AppState, quoteId: string | undefined) {
  const customized = quoteId ? state.quotes?.trades[quoteId]?.tradeNotifications : undefined;
  const userDefault = getUserPreferencesNotifications(state)?.contactIds;
  return customized ?? userDefault ?? emptyContacts;
}
